import OpenZeppelinLogo from "../assets/solhint/logos/openzeppelin.svg";
import POALogo from "../assets/solhint/logos/poa.svg";
import GnosisLogo from "../assets/solhint/logos/gnosis.svg";
import OxLogo from "../assets/solhint/logos/0x.svg";
import EthereumLogo from "../assets/solhint/logos/ethereum.svg";
import OptimismLogo from "../assets/solhint/logos/optimism.svg";
import ContributionIcon from "../assets/solhint/icons/contribution.svg";
import RulesIcon from "../assets/solhint/icons/rules.svg";
import RequestsIcon from "../assets/solhint/icons/requests.svg";
import ChooseIcon from "../assets/solhint/icons/choose.svg";
import Avatars from "../assets/solhint/avatars.png";
import Logo from "../assets/solhint/solhint-logo.png";
import AuditImg from "../assets/solhint/audit.svg";

// eslint-disable-next-line import/prefer-default-export
export const project = {
  name: "Solhint",
  hero: {
    heroTextRows: ["Solhint", "open-source"],
    highlightedText: "Solidity Linter",
    descriptionRows: [
      "An open-source Solidity linter to help you write standardized,",
      "high-quality and secure smart contracts.",
    ],
  },
  brandLogo: {
    usedByTitle: "Used by 1m customers",
    usedBy: [
      { logo: OpenZeppelinLogo, title: "OpenZeppelin" },
      { logo: POALogo, title: "POA" },
      { logo: GnosisLogo, title: "Gnosis" },
      { logo: OxLogo, title: "0x" },
    ],
    trustedByTitle: "Trusted by",
    trustedBy: [
      { logo: EthereumLogo, title: "Ethereum" },
      { logo: OptimismLogo, title: "Optimism" },
    ],
  },
  solhintHelps: {
    title:
      "Solhint helps you write standardized, high-quality and secure smart contracts",
    advantages: [
      "Readable code",
      "Style guides",
      "Security alerts",
      "Prevention from known bugs",
    ],
  },
  stats: [
    { title: "Requests Merged", value: "70+" },
    { title: "User Issues Resolved", value: "100+" },
    { title: "Features Added", value: "4+" },
  ],
  about: {
    title: "About Solhint",
    descriptionParagraphs: [
      "Downloaded 6 million times within the past couple of years, with 3.5 million downloads already in 2023, Solhint has become one of the most used development tools within the Ethereum dev community.",
      "The project releases a new rule set focused on reducing gas consumption, and also evolving the traditional linting features. Solhint suggests the majority of features required for end-to-end coding, removing the necessity to use multiple tools for a complete code-to-release path.",
      "Strong attachment to the traditions of open source and prompt adaptivity to community feedback are the core motivators for the project's growth.",
    ],
  },
  moreInfo: [
    {
      title: "Contribution",
      paragraphs: [
        "We are committed to maintaining a rapid pace of development, and to achieve this goal, we invite volunteers to join us in the evolution of Solhint and contribute to its enhancement.",
        "You can get started by heading to GitHub to pick up your first issue or by joining our Discord server to discuss any suggestions, bugs, or thoughts.",
      ],
      link: "https://github.com/protofire/solhint/blob/develop/docs/contributing.md ",
      icon: ContributionIcon,
    },
    {
      title: "Shareable Rules",
      paragraphs: [
        "Use and extend shareable rules. These can be used as basic configuration and are regular npm packages.",
        "After creating a shareable package you can publish it to npm to make it available for everyone.",
      ],
      link: "https://github.com/protofire/solhint/blob/develop/docs/shareable-configs.md",
      icon: RulesIcon,
    },
    {
      title: "Pull Requests",
      paragraphs: [
        "All code changes happen through pull requests. To create one:",
        [
          "Fork the Solhint repo.",
          "Create your branch from master.",
          "Adjust Solhint for your needs.",
          "Ensure the tests are still passing. Make sure you add tests for new features.",
          "Create the pull request.",
        ],
        "By contributing, you agree that your contributions will be licensed under its MIT License.",
      ],
      link: "https://github.com/protofire/solhint/blob/develop/docs/contributing.md#pull-requests ",
      icon: RequestsIcon,
    },
    {
      title: "Choose Your Rules",
      paragraphs: [
        "We've compiled a set of rules that can be incorporated into any Solidity project.",
        "These rules fall into three primary categories: Best Practices, Style Guide, and Security. Each category is tailored to its core principles, meticulously crafted by seasoned developers, and requested by the community.",
        "Go through our recommended rules listed on GItHub.",
      ],
      link: "https://github.com/protofire/solhint/blob/master/docs/rules.md ",
      icon: ChooseIcon,
    },
  ],
  donate: {
    img: Avatars,
    title: "Donate or Suggest a Grant",
    description:
      "Being an open-source initiative we appreciate any support of yours to the project.",
  },
  contact: {
    title: "Let’s start your project",
    description:
      "Protofire is the blockchain engineer team behind the Solhint development. Reach out for a custom version of Solhint or request a similar tool development for your project.",
  },
  audit: {
    title: "Request smart contract audit",
    description:
      "Smart contract auditing plays an important role in the performance of the blockchain ecosystem, especially when it comes to growth potential. At your request, we will conduct a detailed analysis of your code to identify security problems and incorrect coding with further recommendations for effective improvement.",
    img: AuditImg,
  },
  pressKit: {
    logo: Logo,
    title: "Press Kit",
    description:
      "Download the press kit for your announcement and branding purposes. We appreciate your respect for our project and will be glad to collaborate with you to further build and expand your initiative.",
    link: "/",
  },
};
